import { render, staticRenderFns } from "./BulkUserCreate.vue?vue&type=template&id=0bb5f064&scoped=true&"
import script from "./BulkUserCreate.vue?vue&type=script&lang=js&"
export * from "./BulkUserCreate.vue?vue&type=script&lang=js&"
import style0 from "./BulkUserCreate.vue?vue&type=style&index=0&id=0bb5f064&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5f064",
  null
  
)

export default component.exports